export const ONE_MILLIMETER_IN_FEET = 0.003280839895;
